/* eslint-disable no-console */
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import WebViewer from '@pdftron/webviewer';
import axios from 'axios';
import { XMLParser } from 'fast-xml-parser';
import fileDownload from 'js-file-download';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import appConfig from 'src/appConfig';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import config from 'src/data/config';
import { AppState, store, useAppSelector } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import StyledMenu from 'src/theme/StyledTheme';
import DocManagementService from '../documentUpload/service/DocManagementService';
import SendasLink from '../modelViewer/SendasLink';
import AddtoTasksDialogComponent from './AddtoTasksDialogComponent';
import ApprovalWorkflowDialog from './ApprovalWorkflowDialog';
import AuditHistory from './AuditHistory';
import AccordionMetadataComponent from './component/AccordionComponent';
import './DocumentViewer.scss';
import { GetMetaData } from './helper/DocumentViewerHelper';
import MetaDetail from './MetaDetail';
import MetricsDetails from './MetricsDetails';
import QualityControlDetail from './QualityControlDetail';
import Remove from './Remove';
import ReviewWorkflowDialog from './ReviewWorkflowDialog';
import SendForReviewDialogComponent from './SendForReviewDialogComponent';
import SendToIsfDialog from './SendToIsfDialog';
import VersionHistory from './VersionHistory';
import { DocumentUpload } from '../documentUpload/DocumentUpload';
import moment from 'moment';
import MultiArtifactSendToIsfDialog from './MultiArtifactSendToIsfDialog';
import { setMapIsfArtifacts } from 'src/store/MapIsfArtifacts';
import OverwriteAndSendNewVersionDialog from './OverwriteAndSendNewVersionDialog';

const DocumentViewerComponent = ({
  documentDetails,
  fetchUpdatedData,
  props,
  setDataGridComponent,
  setDisplayDoc,
  isFromViewerVersionHistory = false
}: any) => {
  const metaDataDetails: any = config.documentViewer?.metaDataDetails;
  const optionsMenu: any = config.documentViewer?.optionsMenu;
  const { t } = useTranslation();
  const metaDetailsLocale: any = t('metaDataDetails', { returnObjects: true });
  const documentDetail1: any = useSelector((state: AppState) => state.documentDetail);
  const documentDetail: any = documentDetails && isFromViewerVersionHistory ? documentDetails : documentDetail1;
  const [fileId, setFileId] = useState(`${documentDetail?.data[0]?.fileId}`);
  const viewer: any = useRef(null);
  const docService = new DocManagementService();
  const [pdfLoading, setPdfLoading] = useState(false);
  const [isSentToIsf, setIsSentToIsf] = useState(false);
  const [openVersion, setOpenVersion] = useState(false);
  const [editedFmID, setEditedFmID] = useState('');
  const [annotationsStatus, setAnnotationsStatus] = useState('');
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const xmlParser = new XMLParser();
  const token = useAppSelector(state => state.user.user?.token);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  const siteToken = useAppSelector(state => state.user.user?.siteToken);
  const [selectedRowDocumentDetails, setSelectedRowDocumentDetails] = useState<any>({});
  const { checkPermission, checkPermissionDocViewLevel } = usePermissionWrapper();
  const [docUrl, setDocUrl] = useState('');
  const [actionType, setActionType] = useState('');
  const docFromIsf = documentDetail.data[0]?.tmf_doc_viewer_ref_model_version === 'ISF RM v1.0' ? true : false;
  const isBtnDisabled = documentDetail.data[0]?.isBtnDisabled;
  const [isDisabled, setDisabled] = useState(false);
  const [taskId, setTaskId] = useState('');
  const [taskTitle, setTaskTitle] = useState('');
  const [progress, setProgress] = useState(0);
  const [docVerisonDetails, setDocumentToDisplay1] = useState<any>({});
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const [masterDocumentDetails, setMasterDocumentDetails] = useState({});
  const [latestVersion, setLatestVersion] = useState(0);
  const documentKey: any = useAppSelector(state => state.preferences.documentKey);
  const getCountrySiteFromPreferencesDocKey = (docKey: any, siteOrCountry: string) => {
    if (siteOrCountry === 'Country') {
      return docKey?.country ? docKey?.country : null;
    } else if (siteOrCountry === 'Site') {
      return docKey?.site_id ? docKey?.site_id : null;
    }
  };
  const params = {
    module_section_related: 'DocumentDownload',
    parent_entity_related: documentDetail.data[0].tmf_document_name
  };
  const study = documentKey?.document_id ? documentDetail.data[0].tmf_doc_study : selectedStudy;
  const country = documentKey?.document_id
    ? getCountrySiteFromPreferencesDocKey(documentKey, 'Country')
    : selectedCountry
    ? selectedCountry
    : documentDetail.data[0].tmf_doc_country;
  const site = documentKey?.document_id
    ? getCountrySiteFromPreferencesDocKey(documentKey, 'Site')
    : selectedSite
    ? selectedSite
    : documentDetail.data[0].tmf_doc_site;

  let type = '';
  if (study !== '--' && study !== null && (country === '--' || country === null) && (site === '--' || site === null)) {
    type = `study_id=${study}`;
  } else if (country !== '--' && country !== null && (site === '--' || site === null)) {
    type = `study_id=${study}&country_id=${country}`;
  } else if (site !== '--' && site !== null) {
    type = `study_id=${study}&country_id=${country}&site_id=${site}`;
  }

  const url = async (id = fileId) => {
    const downloadUrl =
      await `${appConfig.appConfig.apietmf}/fileMaster/downloadFile/${id}?application=ETMF&log=Y&original=Y&tmf_doc_level=${documentDetail?.data[0]?.tmf_doc_level}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`;
    setDocUrl(downloadUrl);
  };

  const loadwebViewer = async (id = fileId) => {
    const params = {
      module_section_related: 'DocumentDownload',
      parent_entity_related: documentDetail.data[0].tmf_document_name
    };

    const downloadDocUrl =
      await `${appConfig.appConfig.apietmf}/fileMaster/downloadFile/${id}?application=ETMF&tmf_doc_level=${documentDetail?.data[0]?.tmf_doc_level}&module_section_related=${params.module_section_related}&parent_entity_related=${params.parent_entity_related}`;
    const result = await docService.getVersionHistory(
      documentDetail.data[0]?.tmf_document_id,
      study,
      country,
      site,
      documentDetail.data[0].tmf_doc_level,
      params
    );
    setLatestVersion(result.data[0].document_version.tmf_doc_version_number);
    const tempLatestVersion = result.data[0].document_version.tmf_doc_version_number;
    const response: any = await docService.getMasterDocumentdetails(
      result.data[0].document_version.tmf_doc_study,
      result.data[0].document_version.tmf_document_id,
      docVerisonDetails?.tmf_doc_version_number !== undefined
        ? docVerisonDetails?.tmf_doc_version_number
        : documentDetail.data[0]?.tmf_doc_version_number,
      documentDetail.data[0].tmf_doc_country,
      documentDetail.data[0].tmf_doc_site,
      documentDetail.data[0].tmf_doc_level,
      params
    );

    getQualityControlDetailsById(response);
    setMasterDocumentDetails(response);
    setIsSentToIsf(response.data.need_to_sent_to_isf === 'Yes' ? false : true);
    const docVersion = response?.data?.document_data?.tmf_doc_version_number;
    if (docVersion >= tempLatestVersion) {
      setDisableButton(false);
      setDisableToISF(false);
    } else {
      setDisableButton(true);
      setDisableToISF(true);
    }
    setPdfLoading(false);
    WebViewer(
      {
        path: '/webviewer/lib',
        fullAPI: true
        // initialDoc: downloadDocUrl
      },
      viewer.current
    ).then(instance => {
      setPdfLoading(true);
      const { documentViewer } = instance.Core;
      const { annotationManager } = instance.Core;

      annotationManager.setCurrentUser(userName);
      instance.UI.disableElements([
        'toolbarGroup-Shapes',
        'toolbarGroup-Insert',
        'toolbarGroup-Forms',
        'toolbarGroup-FillAndSign',
        'toolbarGroup-EditText'
      ]);
      if (!checkPermission('add_comments')) {
        instance.UI.disableElements([
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'stickyToolGroupButton',
          'freeTextToolGroupButton',
          'underlineToolGroupButton',
          'shapeToolGroupButton',
          'freeHandToolGroupButton',
          'freeHandHighlightToolGroupButton',
          'contextMenuPopup',
          'annotationCommentButton',
          'annotationStyleEditButton',
          'notePopupEdit'
        ]);
      }

      instance.UI.setToolbarGroup('toolbarGroup-View');
      instance.UI.disableElements(['textEditingPanel']);

      //Load pdf document.
      if (checkPermission('update_document_content')) {
        if (docVersion >= latestVersion) {
          instance.UI.enableElements(['contentEditButton']);
        } else {
          instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
        }
      } else {
        instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
      }

      instance.UI.loadDocument(downloadDocUrl, {
        filename: '',
        customHeaders: {
          Authorization: `bearer ${token}`,
          sponsor: sponsor,
          site_token: siteToken,
          user_date_time: moment().format()
        }
      });

      /**For updating the page num in FileInfo metadata section and saving the new file */

      documentViewer.addEventListener('pagesUpdated', async () => {
        const newPageCount = documentViewer.getPageCount();
        setDocumentDetail(dispatch, [
          {
            ...documentDetail.data[0],
            tmf_doc_viewer_pages: newPageCount
          }
        ]);
        setConfirmExitValue(dispatch, true);
        setOpenVersion(false);
        instance.UI.enableElements(['save-document']);
        instance.UI.setHeaderItems((header: any) => {
          const length = header.headers.default.length;
          if (length === 13) {
            header.push({
              type: 'actionButton',
              title: 'save document',
              dataElement: 'save-document',
              color: '#243F81',
              img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
              onClick: async () => {
                instance.UI.disableElements(['save-document']);
                setPdfLoading(true);
                const doc = documentViewer.getDocument();
                const xfdfString = await annotationManager.exportAnnotations();

                const data = await doc.getFileData({
                  // saves the document with annotations in it
                  xfdfString
                });
                const arr = new Uint8Array(data);
                const fileToUpload = new Blob([arr], { type: 'application/pdf' });
                const file = new File([fileToUpload], documentDetail.data[0].tmf_raw_file_name, {
                  type: 'application/pdf'
                });
                const params = {
                  module_section_related: 'DocumentUpload',
                  parent_entity_related: documentDetail.data[0].tmf_document_name
                };
                const response: any = await docService.fileUpload(
                  file,
                  progress => {
                    setProgress(progress);
                  },
                  study,
                  country,
                  site,
                  documentDetail.data[0].tmf_doc_level,
                  params
                );
                setEditedFmID(response.data.data.id);
                setDocumentDetail(dispatch, [
                  {
                    ...documentDetail.data[0],
                    editedFmID: response.data.data.id,
                    tmf_doc_viewer_pages: response?.data?.data?.tmf_doc_viewer_pages
                  }
                ]);
                setPdfLoading(false);
                setOpenVersion(true);
                setConfirmExitValue(dispatch, false);
                const contentEditManager = documentViewer.getContentEditManager();
                contentEditManager.endContentEditMode();
              }
            });
          }
        });
      });
      /** End */

      documentViewer.addEventListener('documentLoaded', async () => {
        setPdfLoading(false);
        // Get annotation from database using API.
        setAnnotationsStatus('syncing-download');
        if (checkPermission('view_comments')) {
          const params = {
            module_section_related: 'DocumentDetails',
            parent_entity_related: documentDetail.data[0].tmf_document_name
          };

          const response: any = await docService.getAnnotations(
            documentDetail.data[0]?.fmId,
            study,
            country,
            site,
            documentDetail.data[0].tmf_doc_level,
            params
          );

          if (response?.data) {
            annotationManager.importAnnotations(response?.data);
            setPdfLoading(false);
            setAnnotationsStatus('success');
          } else {
            setPdfLoading(false);
            if (response.error?.response?.status === 404) {
              setAnnotationsStatus('success');
            } else {
              setAnnotationsStatus('error');
            }
          }
        }
      });

      annotationManager.addEventListener('annotationChanged', async (annotations, action, { imported }) => {
        annotationManager.exportAnnotations().then(async (result: any) => {
          setAnnotationsStatus('syncing-upload');
          const xfdfDataObj: any = xmlParser.parse(result);
          const selectedAnnotation = annotationManager.getSelectedAnnotations()[0];
          if (selectedAnnotation && selectedAnnotation.isContentEditPlaceholder()) {
            setConfirmExitValue(dispatch, true);
            setOpenVersion(false);
            instance.UI.enableElements(['save-document', 'toolbarGroup-EditText', 'textEditingPanel']);
            instance.UI.setHeaderItems((header: any) => {
              const length = header.headers.default.length;
              if (length === 13) {
                header.push({
                  type: 'actionButton',
                  title: 'save document',
                  dataElement: 'save-document',
                  color: '#243F81',
                  img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
                  onClick: async () => {
                    instance.UI.disableElements(['save-document']);
                    setPdfLoading(true);
                    const doc = documentViewer.getDocument();
                    const xfdfString = await annotationManager.exportAnnotations();

                    const data = await doc.getFileData({
                      // saves the document with annotations in it
                      xfdfString
                    });
                    const arr = new Uint8Array(data);
                    const fileToUpload = new Blob([arr], { type: 'application/pdf' });
                    const file = new File([fileToUpload], documentDetail.data[0].tmf_raw_file_name, {
                      type: 'application/pdf'
                    });
                    const params = {
                      module_section_related: 'DocumentUpload',
                      parent_entity_related: documentDetail.data[0].tmf_document_name
                    };
                    const response: any = await docService.fileUpload(
                      file,
                      progress => {
                        setProgress(progress);
                      },
                      study,
                      country,
                      site,
                      documentDetail.data[0].tmf_doc_level,
                      params
                    );

                    setEditedFmID(response.data.data.id);
                    setDocumentDetail(dispatch, [
                      {
                        ...documentDetail.data[0],
                        editedFmID: response.data.data.id
                      }
                    ]);
                    setPdfLoading(false);
                    setOpenVersion(true);
                    setConfirmExitValue(dispatch, false);
                    const contentEditManager = documentViewer.getContentEditManager();
                    contentEditManager.endContentEditMode();
                  }
                });
              }
            });
          }
          if (checkPermission('add_comments')) {
            if (xfdfDataObj?.xfdf?.annots?.highlight?.contents !== undefined || xfdfDataObj?.xfdf?.annots?.text) {
              const params = {
                module_section_related: 'DocumentAnnotate',
                parent_entity_related: documentDetail.data[0].tmf_document_name
              };

              const response = await docService.sendAnnotations(
                documentDetail.data[0]?.fmId,
                result,
                study,
                country,
                site,
                documentDetail.data[0].tmf_doc_level,
                params
              );
              if (response?.data) {
                setAnnotationsStatus('success');
              } else {
                setAnnotationsStatus('error');
              }
            }
          }
        });
      });
    });
  };

  const getQualityControlDetailsById = async (response: any) => {
    const params = {
      module_section_related: 'DocumentQCControl',
      parent_entity_related: documentDetail.data[0].tmf_document_name
    };
    const result: any = await docService.getQualityControlDetailsById(
      documentDetail.data[0].id,
      study,
      country,
      site,
      documentDetail.data[0].tmf_doc_level,
      params
    );

    const qualityControl = result?.data?.quality_control;

    setDocumentDetail(dispatch, [
      {
        ...documentDetail.data[0],
        is_checkbox_verified: qualityControl ? qualityControl.is_checkbox_verified : false,
        tmf_doc_viewer_qc_issue_type: qualityControl
          ? qualityControl.tmf_doc_viewer_qc_issue_type
          : documentDetail.data[0].tmf_doc_viewer_qc_issue_type,
        tmf_doc_viewer_qc_issue_comments: qualityControl
          ? qualityControl.tmf_doc_viewer_qc_issue_comments
          : documentDetail.data[0].tmf_doc_viewer_qc_issue_commentsqualityControl,
        tmf_doc_viewer_req_certified_copy:
          qualityControl !== undefined
            ? qualityControl.tmf_doc_viewer_req_certified_copy
            : response?.data?.document_data?.tmf_doc_viewer_req_certified_copy,
        tmf_quality_control_table_id: qualityControl?.id,
        is_submit: qualityControl?.is_submit
      }
    ]);
  };

  const statusBasedButtonDiable = async (status: string) => {
    const res = await docService.getActionName(
      documentDetail.data[0]?.tmf_document_id,
      false,
      study,
      country,
      site,
      params,
      documentDetail.data[0].tmf_doc_level,
      true
    );

    switch (status) {
      case 'Approved':
      case 'Ready for approval':
        return setDisabled(true);
      case 'Uploaded':
        if (res?.data?.action_name === 'Send For Review') {
          return setDisabled(true);
        } else if (res?.data ? res?.data?.created_by_email !== user.email : false) {
          return setDisabled(true);
        } else {
          return setDisabled(false);
        }
    }
  };

  const getActionName = async (documentId: string, taskId: string) => {
    let userBasedDetails = true;
    if (documentDetail.data[0].tmf_doc_status === 'Approved') {
      userBasedDetails = false;
    }
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: documentDetail.data[0].tmf_document_name
    };
    const result = await docService.getActionName(
      documentId,
      userBasedDetails,
      study,
      country,
      site,
      params,
      documentDetail.data[0].tmf_doc_level,
      false
    );

    if (documentDetail.data[0].tmf_doc_status === 'Rejected') {
      if (result?.error) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }

    setActionType(result?.data?.action_name);
    setTaskId(result?.data?.task_id);
    setTaskTitle(result?.data?.tasks_title);
  };

  useEffect(() => {
    window.scroll(0, 0);
    getActionName(documentDetail.data[0]?.tmf_document_id, documentDetail.data[0]?.task_Id);
    statusBasedButtonDiable(documentDetail.data[0]?.tmf_doc_status);
    if (documentDetail.data[0].fileId) {
      loadwebViewer(documentDetail.data[0].fileId);
      url(documentDetail.data[0].fileId);
    }
  }, [documentDetail.data[0]?.fileId, documentDetail.data[0]?.tmf_doc_status]);

  const [expanded, setExpanded] = React.useState<string | false>('details');
  const handleToogleAccordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  const dispatch = useDispatch();
  const documentDetailsData: any = documentDetail.data[0];
  const data: any = GetMetaData(documentDetailsData);
  const [openAuditTrail, setOpenAuditTrail] = useState(false);
  const [openVersionHistory, setOpenVersionHistory] = useState(false);
  const [openSendForReviewDialog, setOpenSendForReviewDialog] = useState(false);
  const [openSendAsLinkDialog, setSendAsLinkDialog] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openAddToTaskDialog, setOpenAddToTaskDialog] = useState(false);
  const [actionName, setActionName] = useState('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [buttonText, setButtonText] = useState('');
  const [openReviewDialog, setOpenReviewDialog] = useState(false);
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [openSendToISF, setOpenSendToISF] = useState(false);
  const [openLinkArtifactSendToISF, setOpenLinkArtifactSendToISF] = useState(false);
  const [openOverwriteAndNewversion, setOpenOverwriteAndNewversion] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [disableToISF, setDisableToISF] = useState(false);
  const open3 = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowDocumentDetails(row);
    setDocumentDetail(dispatch, [row]);
  };

  const handleSendForReviewClick = (action: string) => {
    setOpenSendForReviewDialog(true);
    setActionName(action);
  };

  const handleReadyForApprovalClick = (action: string) => {
    setOpenSendForReviewDialog(true);
    setActionName(action);
  };

  const handleClickDownload = (downloadUrl: any) => {
    axios
      .get(downloadUrl, {
        responseType: 'blob'
      })
      .then(res => {
        fileDownload(
          res.data,
          `${documentDetail.data[0] && documentDetail.data[0]?.tmf_document_name}_${parseFloat(
            documentDetail.data[0] && documentDetail.data[0]?.tmf_doc_version_number
          ).toFixed(1)}.${documentDetail.data[0] && documentDetail.data[0]?.docFormat}`
        );
        store.dispatch(setSnackbarMessage('Document is downloaded successfully.', 'success'));
      })
      .catch(error => {
        store.dispatch(setSnackbarMessage(`Enable to download document ${error}.`, 'error'));
      });
  };

  function handleClose3(optionMenuItem: any) {
    if (optionMenuItem.id === 'auditTrail') {
      setOpenAuditTrail(true);
    } else if (optionMenuItem.id === 'versionHistory') {
      setOpenVersionHistory(true);
    } else if (optionMenuItem.id === 'sendAsLink') {
      setSendAsLinkDialog(true);
    } else if (optionMenuItem.id === 'remove') {
      setOpenRemoveDialog(true);
    } else if (optionMenuItem.id === 'download') {
      handleClickDownload(docUrl);
    } else if (optionMenuItem.id === 'addToTasks') {
      setOpenAddToTaskDialog(true);
    }
    {
      setAnchorEl(null);
    }
  }

  const handleOpenDialog = async (text: string) => {
    setButtonText(text);
    if (text === 'Reject' || text === 'Complete Review') {
      setOpenReviewDialog(true);
    } else if (text === 'SendToIsf') {
      const payload = { tmf_document_ids: [documentDetail.data[0]?.tmf_document_id] };
      const resp: any = await docService.VersionBasedDocument(payload);
      if (!documentDetail.data[0]?.sent_to_isf && !resp.data) {
        const data = { tmf_artifact_number: [documentDetail.data[0]?.tmf_artifact_number] };
        const res: any = await docService.TmfLinkArtifacts(data);
        if (res?.error) {
          store.dispatch(setSnackbarMessage(`The selected documents are not eligible to be send to ISF`, 'error'));
        } else if (res?.data.length <= 1) {
          setOpenSendToISF(true);
        } else {
          dispatch(setMapIsfArtifacts(res?.data));
          setOpenLinkArtifactSendToISF(true);
        }
      } else {
        setOpenOverwriteAndNewversion(true);
      }
    } else {
      setOpenApproveDialog(true);
    }
  };

  const [checked, setChecked] = React.useState(true);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  return checkPermissionDocViewLevel('view_uploaded_document', 'DocLevel') !== false ? (
    <div>
      <h2 style={{ margin: 0 }}>Viewer</h2>
      <Grid container className="document-view-header" spacing={2}>
        <Grid item xs>
          <Typography>{documentDetail.data[0] && documentDetail.data[0]?.tmf_document_name} </Typography>
        </Grid>
        <Grid item xs display="flex" justifyContent="flex-end">
          <Stack spacing={1} direction="row" sx={{ mb: 0.5 }}>
            <div style={{ minWidth: '150px' }}>
              <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
              <span>View Details</span>
            </div>
            {documentDetail.data[0].sent_to_isf === true ? (
              <Alert severity="success" color="info" sx={{ py: '2px' }}>
                Document is sent to ISF
              </Alert>
            ) : documentDetail.data[0].tmf_doc_status === 'Approved' &&
              documentDetail.data[0].tmf_doc_level === 'Site' &&
              documentDetail.data[0]?.tmf_doc_version_number % 1 === 0 ? (
              <Stack spacing={1} direction="row">
                <Button
                  variant="contained"
                  className={
                    !checkPermission('send_to_isf') ||
                    // actionType === 'Sent To ISF' ||
                    documentDetail.data[0].tmf_doc_level === 'Country' ||
                    documentDetail.data[0].tmf_doc_level === 'Study' ||
                    documentDetail.data[0].tmf_doc_viewer_ref_model_version.slice(0, 3) === 'ISF'
                      ? 'hide'
                      : ''
                  }
                  onClick={() => handleOpenDialog('SendToIsf')}
                  disabled={isSentToIsf || disableToISF}
                >
                  TO ISF
                </Button>
              </Stack>
            ) : actionType === 'Send For Review' ? (
              <Stack spacing={1} direction="row">
                <Button
                  variant="contained"
                  onClick={() => handleOpenDialog('Complete Review')}
                  disabled={disableButton}
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  COMPLETE REVIEW
                </Button>
                <Button variant="contained" onClick={() => handleOpenDialog('Reject')} disabled={disableButton}>
                  REJECT
                </Button>
              </Stack>
            ) : actionType === 'Ready For Approval' ? (
              <Stack spacing={1} direction="row">
                <Button variant="contained" onClick={() => handleOpenDialog('Approve')} disabled={disableButton}>
                  APPROVE
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleOpenDialog('Approval Reject')}
                  disabled={disableButton}
                >
                  REJECT
                </Button>
              </Stack>
            ) : (
              <Stack spacing={1} direction="row">
                <Button
                  variant="contained"
                  className={documentDetail.data[0].tmf_doc_status === 'Approved' ? 'hide' : ''}
                  disabled={
                    !checkPermissionDocViewLevel('send_document_for_approval', 'DocLevel') ||
                    isDisabled ||
                    isBtnDisabled ||
                    disableButton
                  }
                  onClick={() => handleReadyForApprovalClick('Ready For Approval')}
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  READY FOR APPROVAL
                </Button>
                <Button
                  variant="contained"
                  className={documentDetail.data[0].tmf_doc_status === 'Approved' ? 'hide' : ''}
                  disabled={
                    !checkPermissionDocViewLevel('send_document_for_review', 'DocLevel') ||
                    isDisabled ||
                    isBtnDisabled ||
                    disableButton
                  }
                  onClick={() => handleSendForReviewClick('Send For Review')}
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  SEND FOR REVIEW
                </Button>
              </Stack>
            )}
            <div>
              <Button
                className="grey-btn transparent-btn"
                id="demo-customized-button"
                aria-controls={open3 ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open3 ? 'true' : undefined}
                disableElevation
                onClick={(e: any) => handleClick(e, documentDetailsData)}
              >
                <MoreHorizIcon />
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  'aria-labelledby': 'demo-customized-button'
                }}
                anchorEl={anchorEl}
                open={open3}
                onClose={handleClose3}
                className="more-button-list"
              >
                {optionsMenu?.map((optionMenuItem: any, index: number) => {
                  if (optionMenuItem.id === 'sendAsLink') {
                    if (optionMenuItem.isEnabled) {
                      return (
                        <MenuItem
                          onClick={() => handleClose3(optionMenuItem)}
                          key={index}
                          disableRipple
                          disabled={!(checkPermission('send_document_as_link') && optionMenuItem.isEnabled)}
                          className={docFromIsf ? 'hide' : ''}
                        >
                          {optionMenuItem.icon}
                          {optionMenuItem.name}
                        </MenuItem>
                      );
                    }
                  } else if (optionMenuItem.id === 'auditTrail') {
                    if (checkPermission('view_audit_history') && optionMenuItem.isEnabled) {
                      return (
                        <MenuItem
                          onClick={() => handleClose3(optionMenuItem)}
                          disableRipple
                          key={index}
                          className={docFromIsf ? 'hide' : ''}
                        >
                          {optionMenuItem.icon}
                          {optionMenuItem.name}
                        </MenuItem>
                      );
                    }
                  } else if (optionMenuItem.id === 'versionHistory') {
                    if (checkPermission('view_version_history') && optionMenuItem.isEnabled) {
                      return (
                        <MenuItem
                          onClick={() => handleClose3(optionMenuItem)}
                          disableRipple
                          key={index}
                          className={docFromIsf ? 'hide' : ''}
                        >
                          {optionMenuItem.icon}
                          {optionMenuItem.name}
                        </MenuItem>
                      );
                    }
                  } else if (optionMenuItem.id === 'download') {
                    return (
                      <MenuItem
                        disabled={!checkPermissionDocViewLevel('download_document', 'DocLevel')}
                        onClick={() => handleClose3(optionMenuItem)}
                        disableRipple
                        key={index}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.id === 'remove') {
                    return (
                      <MenuItem
                        disabled={
                          !checkPermission('delete_document') ||
                          !checkPermissionDocViewLevel('delete_document', 'DocLevel')
                        }
                        onClick={() => handleClose3(optionMenuItem)}
                        key={index}
                        disableRipple
                        className={docFromIsf ? 'hide' : ''}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.id === 'addToTasks') {
                    return (
                      <MenuItem
                        disabled={
                          !checkPermission('add_to_task') ||
                          (documentDetail.data[0]?.tmf_doc_latest_version
                            ? parseFloat(documentDetail.data[0]?.tmf_doc_version_number)?.toFixed(1) !==
                              parseFloat(documentDetail.data[0]?.tmf_doc_latest_version)?.toFixed(1)
                            : documentDetail.data[0]?.tmf_doc_version_number < latestVersion)
                        }
                        key={index}
                        onClick={() => handleClose3(optionMenuItem)}
                        disableRipple
                        className={docFromIsf ? 'hide' : ''}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose3(optionMenuItem)} disableRipple>
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                })}
              </StyledMenu>
            </div>
          </Stack>
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={12} sm={12} md={checked ? 8 : 12} className="doc-view-panel">
          <div className="App">
            {pdfLoading && (
              <Box sx={{ width: '100%' }}>
                <LinearProgress />
              </Box>
            )}
            <div className="webviewer" ref={viewer} key={documentDetail.data[0]?.fileId}></div>
          </div>
        </Grid>
        {checked ? (
          <Grid xs={12} sm={12} md={4} className="docview-details-accordion">
            <div className="pi-accordion">
              {metaDataDetails?.map((metaDataSection: any, index: any) => {
                if (index > 2) {
                  return (
                    <AccordionMetadataComponent
                      accordionInfo={{ name: metaDetailsLocale[metaDataSection.key], position: metaDataSection.key }}
                      expanded={expanded}
                      key={index}
                      handleToogleAccordion={handleToogleAccordion}
                      data={data[metaDataSection.key]}
                    ></AccordionMetadataComponent>
                  );
                } else {
                  return (
                    <>
                      {index === 0 && (
                        <MetaDetail
                          accordionInfo={{
                            name: metaDetailsLocale[metaDataSection.key],
                            position: metaDataSection.key
                          }}
                          expanded={expanded}
                          handleToogleAccordion={handleToogleAccordion}
                          documentProps={documentDetails}
                          fetchUpdatedData={fetchUpdatedData}
                          latestVersion={latestVersion}
                        />
                      )}
                      {index === 1 && (
                        <QualityControlDetail
                          accordionInfo={{
                            name: metaDetailsLocale[metaDataSection.key],
                            position: metaDataSection.key
                          }}
                          expanded={expanded}
                          handleToogleAccordion={handleToogleAccordion}
                          documentProps={documentDetails}
                          fetchUpdatedData={fetchUpdatedData}
                          actionType={actionType}
                          status={documentDetail.data[0].tmf_doc_status}
                        />
                      )}
                      {index === 2 && (
                        <MetricsDetails
                          accordionInfo={{
                            name: metaDetailsLocale[metaDataSection.key],
                            position: metaDataSection.key
                          }}
                          expanded={expanded}
                          handleToogleAccordion={handleToogleAccordion}
                          documentProps={documentDetails}
                          fetchUpdatedData={fetchUpdatedData}
                          actionType={actionType}
                        />
                      )}
                    </>
                  );
                }
              })}
            </div>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      {openSendForReviewDialog && (
        <SendForReviewDialogComponent
          openSendForReviewDialog={openSendForReviewDialog}
          setOpenSendForReviewDialog={setOpenSendForReviewDialog}
          qualityControlId={documentDetail.data[0]?.tmf_quality_control_table_id}
          actionName={actionName}
          documentDetail={documentDetail}
          taskId={documentDetail.data[0]?.task_Id}
        />
      )}

      {openAuditTrail && (
        <AuditHistory
          openAuditTrail={openAuditTrail}
          setOpenAuditTrail={setOpenAuditTrail}
          setAnchorEl={setAnchorEl}
          setFileId={setFileId}
        />
      )}
      {openVersionHistory && (
        <VersionHistory
          openVersionHistory={openVersionHistory}
          setOpenVersionHistory={setOpenVersionHistory}
          setAnchorEl={setAnchorEl}
          setFileId={setFileId}
          setDocumentToDisplay1={setDocumentToDisplay1}
          setDisableButton={setDisableButton}
          setDisableToISF={setDisableToISF}
        />
      )}
      {openSendAsLinkDialog && (
        <SendasLink
          openSendAsLinkDialog={openSendAsLinkDialog}
          setSendAsLinkDialog={setSendAsLinkDialog}
          setAnchorEl={setAnchorEl}
          setFileId={setFileId}
          documentDetails={selectedRowDocumentDetails}
        />
      )}
      {openRemoveDialog && (
        <Remove
          openRemoveDialog={openRemoveDialog}
          setOpenRemoveDialog={setOpenRemoveDialog}
          props={props}
          setDataGridComponent={setDataGridComponent}
        />
      )}
      {openAddToTaskDialog && (
        <AddtoTasksDialogComponent
          openAddToTaskDialog={openAddToTaskDialog}
          setOpenAddToTaskDialog={setOpenAddToTaskDialog}
          actionName={actionName}
        />
      )}
      {openReviewDialog && (
        <ReviewWorkflowDialog
          openReviewDialog={openReviewDialog}
          setOpenReviewDialog={setOpenReviewDialog}
          buttonText={buttonText}
          setDisableButton={setDisableButton}
          taskId={taskId}
          taskTitle={taskTitle}
        />
      )}
      {openApproveDialog && (
        <ApprovalWorkflowDialog
          openApproveDialog={openApproveDialog}
          setOpenApproveDialog={setOpenApproveDialog}
          buttonText={buttonText}
          setDisableButton={setDisableButton}
          setIsSentToIsf={setIsSentToIsf}
          taskId={taskId}
          taskTitle={taskTitle}
        />
      )}
      {openSendToISF && (
        <SendToIsfDialog
          openSendToISF={openSendToISF}
          setOpenSendToISF={setOpenSendToISF}
          taskId={taskId}
          setIsSentToIsf={setIsSentToIsf}
        />
      )}
      {openVersion && (
        <DocumentUpload dataGridComponent={true} openVersion={openVersion} docViewer={true} editedFmID={editedFmID} />
      )}
      {openLinkArtifactSendToISF && (
        <MultiArtifactSendToIsfDialog
          openLinkArtifactSendToISF={openLinkArtifactSendToISF}
          setOpenLinkArtifactSendToISF={setOpenLinkArtifactSendToISF}
          taskId={taskId}
          setIsSentToIsf={setIsSentToIsf}
        />
      )}
      {openOverwriteAndNewversion && (
        <OverwriteAndSendNewVersionDialog
          openOverwriteAndNewversion={openOverwriteAndNewversion}
          setOpenOverwriteAndNewversion={setOpenOverwriteAndNewversion}
          taskId={taskId}
          setIsSentToIsf={setIsSentToIsf}
        />
      )}
    </div>
  ) : (
    <Grid container justifyContent={'center'} alignItems="center" style={{ minHeight: '100vh' }}>
      <h4>You don’t have required permission to view the document. Please contact administrator</h4>
    </Grid>
  );
};

export default memo(DocumentViewerComponent);
